import PropTypes from 'prop-types'
import { Icon } from '..'
import { ButtonContainer } from './style'

const Button = ({ label, icon, ...rest }) => {
  return (
    <ButtonContainer {...rest} hasIcon={icon}>
      {label}
      {!!icon && <Icon name={icon} />}
    </ButtonContainer>
  )
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  icon: PropTypes.string,
  isGoogle: PropTypes.bool,
  isFacebook: PropTypes.bool,
  isApple: PropTypes.bool,
}

export default Button
